import React, { useContext, useMemo } from 'react';

import V5GadgetFormContext from 'contexts/V5GadgetFormContext';

import Dropdown from '../../Inputs/Dropdown';
import Label from '../Label';
import { InputWrapper } from '../styles';

const TotalsColumnPositionInput = () => {
  const {
    totalsColumnPosition,
    setTotalsColumnPosition,
    reverseAxes,
    draftChart,
  } = useContext(V5GadgetFormContext);

  const position = totalsColumnPosition ?? 'last';

  const options = useMemo(
    (): DropdownOption[] => [
      {
        label: 'Last',
        subLabel: 'Show the Total column after the data columns',
        isSelected: position === 'last',
        onSelected: () => setTotalsColumnPosition('last'),
      },
      {
        label: 'First',
        subLabel: 'Show the Total column before the data columns',
        isSelected: position === 'first',
        onSelected: () => setTotalsColumnPosition('first'),
      },
    ],
    [position, setTotalsColumnPosition],
  );

  if (draftChart && draftChart.gadgetType === 'matrix' && !!reverseAxes) {
    return (
      <InputWrapper>
        <Label>Totals column position</Label>
        <Dropdown options={options} />
      </InputWrapper>
    );
  }
  return null;
};

export default TotalsColumnPositionInput;
